export const colorSchemes = {
  [`brand.success`]: {
    bg: `background.state.success-subtle`,
    borderColor: `stroke.state.success-bold`,
    color: `stroke.state.success-bold`,
  },
  [`brand.danger`]: {
    bg: `background.state.danger-subtle`,
    borderColor: `stroke.state.danger-bold`,
    color: `stroke.state.danger-bold`,
  },
  [`brand.warning`]: {
    bg: `background.state.warning-subtle`,
    borderColor: `stroke.state.warning-bold`,
    color: `stroke.state.warning-bold`,
  },
  yellow: {
    bg: `yellow.200`,
    borderColor: `yellow.600`,
    color: `yellow.600`,
  },
  [`brand.primary`]: {
    bg: `brand.primary.200`,
    color: `brand.primary.600`,
    borderColor: `brand.primary.600`,
  },
  [`electric-indigo`]: {
    bg: `electric-indigo.200`,
    color: `electric-indigo.600`,
    borderColor: `electric-indigo.600`,
  },
  [`snappy-violet`]: {
    bg: `snappy-violet.200`,
    color: `snappy-violet.600`,
    borderColor: `snappy-violet.600`,
  },
  obsidian: {
    bg: `obsidian.200`,
    color: `obsidian.600`,
    borderColor: `obsidian.600`,
  },
  [`generic-viridian`]: {
    bg: `generic-viridian.200`,
    color: `generic-viridian.600`,
    borderColor: `generic-viridian.600`,
  },
  [`lucky-orange`]: {
    bg: `lucky-orange.200`,
    color: `lucky-orange.600`,
    borderColor: `lucky-orange.600`,
  },
  [`purple-sea`]: {
    bg: `purple-sea.200`,
    color: `purple-sea.600`,
    borderColor: `purple-sea.600`,
  },
  [`psychedelic-purple`]: {
    bg: `psychedelic-purple.200`,
    color: `psychedelic-purple.600`,
    borderColor: `psychedelic-purple.600`,
  },
  [`sea-sight`]: {
    bg: `sea-sight.200`,
    color: `sea-sight.600`,
    borderColor: `sea-sight.600`,
  },
  [`blue-spark`]: {
    bg: `blue-spark.200`,
    color: `blue-spark.600`,
    borderColor: `blue-spark.600`,
  },
  [`electric-crimson`]: {
    bg: `electric-crimson.200`,
    color: `electric-crimson.600`,
    borderColor: `electric-crimson.600`,
  },
  [`golden-stone`]: {
    bg: `golden-stone.200`,
    borderColor: `golden-stone.600`,
    color: `golden-stone.600`,
  },
};

/** Gets the same color for the same input */
export const getColorScheme = (scheme: string, omit: Array<string> = [], fallback?: keyof typeof colorSchemes) => {
  // If colorScheme is already a color, return it
  if (colorSchemes[scheme as keyof typeof colorSchemes]) {
    return {value: colorSchemes[scheme as keyof typeof colorSchemes], name: scheme};
  } else if (fallback) {
    return {value: colorSchemes[fallback], name: fallback};
  }

  if (!scheme && !fallback) {
    return {value: colorSchemes.obsidian, name: `gray`};
  }

  // Compute colorScheme for the input provided
  const colors = Object.keys(colorSchemes).filter(color => !omit.includes(color));

  // Compute ASCII sum of characters
  let sum = 0;
  for (let i = 0; i < scheme.length; i++) sum += scheme.charCodeAt(i);

  // Use modulo operator to get a deterministic index into the colors array
  const color = colors[sum % colors.length];
  return {value: colorSchemes[color as keyof typeof colorSchemes], name: color};
};
